
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evento/[id]",
      function () {
        return require("private-next-pages/evento/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evento/[id]"])
      });
    }
  